<template>
  <form
    class="wrapper-form row shadow py-4 mb-5"
    @submit.prevent="submitForm"
    data-vv-scope="formPassword"
  >
    <div class="col-lg-12 col-12">
      <div class="group-form">
        <input
          type="password"
          v-validate="{ required: true, regex: /^(?=.*\d).{8,}$/ }"
          name="current_password"
          :class="{active:formPassword.current_password != ''}"
          v-model="formPassword.current_password"
        >
        <span class="bar"></span>
        <label>{{ $t('label.password')}}</label>
        <span
          v-if="errors.has('formPassword.current_password')"
          class="is-danger"
        >{{$t('message.require.error.password')}}</span>
      </div>
    </div>
    <div class="col-lg-12 col-12">
      <div class="group-form">
        <input
          v-validate="{ required: true, regex: /^(?=.*\d).{8,}$/ }"
          name="newPassword"
          type="password"
          :class="{active:formPassword.new_password != ''}"
          v-model="formPassword.new_password"
        >
        <span class="bar"></span>
        <label>{{ $t('label.newPassword')}}</label>
        <span
          v-if="errors.has('formPassword.newPassword')"
          class="is-danger"
        >{{$t('message.require.error.password')}}</span>
      </div>
    </div>
    <div class="col-lg-12 col-12">
      <div class="group-form">
        <input
          v-validate="'required|confirmed:newPassword'"
          data-vv-as="newPassword"
          name="re_new_password"
          type="password"
          :class="{active:formPassword.re_new_password != ''}"
          v-model="formPassword.re_new_password"
        >
        <span class="bar"></span>
        <label>{{ $t('label.re_password')}}</label>
        <span
          v-if="errors.has('formPassword.re_new_password')"
          class="is-danger"
        >{{$t('message.require.error.re_password')}}</span>
      </div>
    </div>
    <div class="col-12">
      <div class="form-action">
        <button class="font-16 px-5 py-2 bttn-fill bttn bttn-success" v-ripple>ذخیره</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'password',
  data() {
    return {
      formPassword: {
        current_password: '',
        new_password: '',
        re_new_password: ''
      }
    }
  },
  methods: {
    async submitForm() {
      let result = await this.$validator.validateAll('formPassword')
      if (!result) {
        this.$root.showWarnMsg({
          message: 'لطفا فرم را تکمیل کنید ... '
        })
        return
      }
      this.$emit('submitPassword', this.formPassword)

    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard-component/password/index.vue